module.exports = __webpack_public_path__ + "img/hic-genitourinary-diseases-male.32965d28.png";